<template>
  <a-modal v-model="modal" title="批量差异处理" width="60%" :maskClosable="false" :dialog-style="{ top: '30px' }" :body-style="{ maxHeight: '80vh', overflowY: 'auto' }">
    <div>
      <ls-info-form>
        <ls-info-item title="生效日期" slot="startDate">
          <a-date-picker v-model="startDate" valueFormat="YYYY-MM-DD 00:00:00" :disabled-date="disabledDate" style="width: 200px"/>
        </ls-info-item>
      </ls-info-form>
      <a-divider style="margin: 12px 0"/>
      <div style="margin-bottom: 10px; font-weight: 500;">已选物料清单（共 {{ dataSource.length }} 条）</div>
      <a-table
        bordered
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
        row-key="id"
        :scroll="{ y: '40vh' }"
        size="small"
      ></a-table>
    </div>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="onBatchApply(false)">不升级</a-button>
        <a-button type="primary" :loading="loading" @click="onBatchApply(true)">确认升级</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiMbomBillStructuresBatchApply } from '@/api/mdm/matter/manufacture-mbom.js'
export default {
  name: "BatchDifferenceModal",
  components: {},
  data () {
    return {
      modal: false,
      loading: false,
      startDate: undefined,
      dataSource: [],
      columns: [
        { title: '物料编码', width: 150, align: 'center', dataIndex: 'itemCode' },
        { title: '物料名称', width: 150, align: 'center', dataIndex: 'itemName' },
        { title: '物料描述', width: 200, align: 'center', dataIndex: 'itemDescription' },
        { title: 'MBOM版本号', width: 100, align: 'center', dataIndex: 'mbomVersion' },
        { title: '来源PBOM版本号', width: 100, align: 'center', dataIndex: 'pbomVersion' }
      ]
    }
  },
  methods: {
    show(selectedRows) {
      this.dataSource = [...selectedRows]
      this.startDate = this.$moment(new Date()).format('YYYY-MM-DD 00:00:00')
      this.modal = true
    },
    validateStartDate() {
      if (!this.startDate) {
        this.$message.error('请选择生效日期')
        return false
      }
      const selectedDate = this.$moment(this.startDate)
      const today = this.$moment().startOf('day')
      if (selectedDate.isBefore(today)) {
        this.$message.error('生效日期不能早于当天')
        return false
      }
      return true
    },
    onBatchApply(upgradeFlag) {
      if (!this.validateStartDate()) {
        return
      }
      const ids = this.dataSource.map(item => item.id)
      const params = {
        ids: ids,
        startDate: this.startDate,
        upgradeFlag: upgradeFlag
      }
      this.loading = true
      apiMbomBillStructuresBatchApply(params).then(res => {
        if (res?.code === 200) {
          this.$message.success(res?.msg || '操作成功')
          this.modal = false
          this.$emit('refresh')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day')
    }
  }
}
</script>

<style scoped>
</style>
